import React from "react";
import CategoryRecipes from "../recipe-category";
import { Container } from "react-bootstrap";
import RecipeAuthors from "../recipes-authors-section";

const RecipesCategorySection = ({ data }) => {

  return (
    <div>
      <Container>
        {data?.title &&
          <h3>{data?.title}</h3>
        }
      </Container>
      {data?.authorModule ? <RecipeAuthors authors={data?.authors}/>
        : <CategoryRecipes recipes={data?.recipes} section={true}/>}
    </div>

  );
};

export default RecipesCategorySection;